import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css']
})
export class BlogsComponent implements OnInit {
  isBrowser: boolean = false;

  baseUrl = Constants.baseUrl;
  constructor(
    private titleService: Title, @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private seoService: SeoService,
    private metaService: Meta
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Blogs - Technology Consulting and IT services | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'We are a professional IT services provider with years of experience working with organizations in the financial services and banking sectors. Contact us!' }
    ]);
  }



  selectedFilter: string = 'all';
  blogs = [



    {
      title: 'The Next Frontier in Human-Machine Conversations Powered by NLP | Maganti IT',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/human-machine-img.webp',
      description: 'Imagine waking up in a world where your coffee machine brews your favorite blend simply because you smiled at it, or your car knows to play your preferred podcast as you buckle your seatbelt.',
      link: 'human-machine-conversations',
      type: ''

    },


    {
      title: 'Cloud Disaster Recovery: Proven Strategies Every IT Leader Should Know',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/cloud-disaster-banner.webp',
      description: 'Explore best practices and proven approaches for cloud disaster recovery with expert insights and practical steps.',
      link: 'cloud-disaster-recovery',
      type: ''

    },
    {
      title: 'Modernize Your Data Centers with Cloud Computing: An imperative for today’s businesses',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/datacenters-image.webp',
      description: "Explore how cloud computing can solve key challenges of today's modern businesses and deliver benefits to your data centers.",
      link: 'datacenterswithcloud-computing',
      type: ''

    },
    {
      title: 'Top 16 cloud security best practices that boost the overall security of your Azure deployments',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/azzure-banner-img.webp',
      description: 'Read the top Azure Cloud security best practices from the experts to safeguard your cloud environment from threats and enhance the overall security of your Azure deployments.',
      link: 'azure-deployments',
      type: ''

    },

    {
      title: 'Gen AI Powered Talent Acquisition for Candidate Profiling and Job-Fit Analysis',
      category: '',
      image: 'assets/images/blogs/GenAI-Powered.webp',
      description: "The high demand for top talent in today's job market challenges recruiters to efficiently           find and screen qualified candidates among numerous applicants, a task that's both time-consuming and prone to missing ideal hires.",
      link: 'genai-powered-talentacquisition-candidate-profiling-and-job-fit-analysis',
      type: ''
    },
    {
      title: 'Empowering Teams with AI: A Deep Dive into RFP Chatbot Implementation and Results',
      category: '',
      image: 'assets/images/blogs/Rfpchatbot.webp',
      description: 'Managing Requests for Proposals (RFPs) is a complex and time-consuming challenge.   It necessitates a deep dive into detailed requirements, careful analysis, and substantial time investment in drafting compelling responses.',
      link: 'a-deep-dive-into-rfp-chatbot-implementation-and-results',
      type: ''

    },
    {
      title: 'How does e-Commerce Influence Supply Chain Management?',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/supply-chain-management.png',
      description: 'Gain insights into the evolving landscape of supply chain management in manufacturing, fueled by the integration of e-commerce technologies and strategies.',
      link: ' e-commerce-influence-supply-chain-management',
      type: ''

    },
    {
      title: 'Gain a Competitive Advantage with ERP',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/gain-competitive.png',
      description: 'Explore how our ERP solutions can revolutionize your operations, boost efficiency, and keep you competitive.',
      link: 'gain-competitive-advantage-with-erp',
      type: ''

    },
    {
      title: 'Production planning ERP for better manufacturing efficiency',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/production-planning-banner.png',
      description: 'Read how custom ERP enhances production planning, from optimizing resource use to accelerating order fulfillment.',
      link: 'production-planning-erp-for-better-manufacturing-efficiency',
      type: ''

    },
    {
      title: ' Exploring the Impact of AI on Manufacturing Challenges',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/Exploring-the-Impact-of-AI-blog.png',
      description: "AI's integration into manufacturing is revolutionizing how businesses tackle long-standing challenges. Read blog on how AI is profoundly impacting the manufacturing industry.",
      link: 'exploring-the-impact-of-ai-on-manufacturing-challenges-blog',
      type: ''

    },

    {
      title: 'Unlocking Remote Work\'s Potential',
      category: 'HR and Recruiting',
      image: 'assets/images/blogs/unlock_remote_work-blog.webp',
      description: 'Discover how remote work is reshaping the future of business, enhancing productivity and diversity, and learn practical strategies for organizations to successfully adopt a remote-first approach.',
      link: 'unlock_remote_work',
      type: 'Technology'
    },
    {
      title: 'What is Smart Manufacturing, and how is it changing the industry?',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/smart-manufacturing-blog.webp',
      description: 'Discover how smart manufacturing solutions can revolutionize your manufacturing operations, enhancing efficiency, productivity, and market competitiveness.',
      link: 'What-is-smart-manufacturing',
      type: 'Technology'
    },
    {
      title: 'Power Up your Production: Strategies for OEE Improvement in Your Manufacturing business',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/oee-improvement-banner.webp',
      description: 'Discover six expert strategies to boost your manufacturing business\'s Overall Equipment Effectiveness (OEE) through custom software solutions.',
      link: 'oee-improvement-for-manufacturing',
      type: 'Technology'
    },
    {
      title: 'Celebrating Women: Honoring Their Contributions to Society, Family, and Work',
      category: 'HR and Recruiting',
      image: 'assets/images/banners/celebrating-women-blog.webp',
      description: 'Let\'s celebrate and empower women this International Women\'s Day for a more inclusive future. Read the blog.',
      link: 'celebrating-women-blog',
      type: 'Technology'
    },
    {
      title: 'From Reactive to Proactive: How Predictive Analytics Improves OEE in Manufacturing',
      category: 'Manufacturing IT',
      image: 'assets/images/blogs/reactive-blog-img.png',
      description: 'Learn how predictive analytics can boost equipment utilization by 5% to 15% and enhance OEE metrics, unlocking significant manufacturing benefits.',
      link: 'reactivetoproactive-blog',
      type: 'Technology'
    },
    {
      title: 'Achieving Harmony: The Importance of Work-Life Balance',
      category: 'HR and Recruitment',
      image: 'assets/images/blogs/Achievingharmony-blog.png',
      description: 'Discover how maintaining a healthy work-life balance, a crucial element for overall well-being, can improve your physical, mental, and emotional health in our latest blog post.',
      link: 'achieving-harmony-blog',
      type: 'Technology'
    },
    {
      title: 'Unlocking the Productivity in the Workplace',
      category: 'HR and Recruitment',
      image: 'assets/images/blogs/unlocking-img-blog.png',
      description: 'In today\'s dynamic professional environment, achieving productivity has become synonymous with achieving success.',
      link: 'unlockingtheproductivity-blog',
      type: 'Technology'
    },
    {
      title: 'How Technology can Amplify Business Efficiency for Manufacturers in Industry 4.0',
      category: 'Infographic',
      image: 'assets/images/blogs/blog-img.png',
      description: 'Amidst stringent deadlines and personal aspirations, learn how you can tap into your maximum potential and enhance productivity in the workplace. Read the blog.',
      link: 'manufacturing_technology_efficiency_industry4_0',
      type: 'Technology'
    },
    {
      title: '7 Important Test Cases for Your E-Commerce Website Success',
      category: 'Testing Services',
      image: 'assets/images/blogs/testcasesimage.png',
      description: 'The e-commerce sector has experienced remarkable growth, drawing businesses of all sizes into the digital marketplace.',
      link: 'testcasesforecommerce',
      type: 'Technology'
    },
    {
      title: 'The Key to Employee Happiness: Achieving Work-Life Balance',
      category: 'IT Staffing',
      image: 'assets/images/blogs/WorkLifeBalance.png',
      description: 'Managing today\'s extensive cloud infrastructure demands modern IT services. Learn more in our blog.',
      link: 'it-staffing',
      type: 'Technology'
    },
    {
      title: 'AI for E-Commerce: Enhancing Customer Experiences & Business Success',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/AI-Solutions-bg.png',
      description: 'Artificial Intelligence (AI) is proving to be a game-changer in streamlining processes and enhancing customer experiences.',
      link: 'ai-solutions-for-e-commerce',
      type: 'Technology'
    },
    {
      title: 'Client Story: Protecting Personal Identifiable Information (PII) using AI/ML',
      category: 'Artificial Intelligence',
      image: 'assets/images/blogs/pii-banner1.png',
      description: 'The financial services industry operates and deals with vast amounts of sensitive data. Learn how AI and ML can protect this information.',
      link: 'pii-use-case-ai-ml',
      type: 'Technology'
    },
    {
      title: 'Client Story: Cloud Optimization Strategies That Drove 50% Cost Savings',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/cloud-cost.png',
      description: '64% of respondents identified cost management as a key challenge. Learn how cloud optimization strategies can help.',
      link: 'cloud-cost-optimization',
      type: 'Technology'
    },
    {
      title: 'Planning Cloud Capacity for Unexpected Spikes in Server Workloads',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/planning-cloud.png',
      description: 'Most CIOs and cloud engineers agree on the importance of planning cloud capacity for unexpected spikes in server workloads.',
      link: 'planning-cloud-capacity',
      type: 'Technology'
    },
    {
      title: 'Personalization and Machine Learning in Marketing',
      category: 'Artificial Intelligence',
      image: 'assets/images/blogs/blog_mainimage.png',
      description: 'Technology is becoming increasingly personalized. Discover how AI and ML are changing the marketing landscape.',
      link: 'personalize-and-machine-learning',
      type: 'Technology'
    },
    {
      title: 'The New Wave of Digital Marketing in the Post-Pandemic World',
      category: 'Digital Marketing',
      image: 'assets/images/blogs/digitalmarketingpostpandemic.webp',
      description: 'COVID-19 accelerated the pace of digital transformation. Learn about the new wave of digital marketing strategies in our blog.',
      link: 'postpandamic',
      type: 'digital_marketing'
    },
    {
      title: 'Why is Cloud Migration Critical in the COVID-19 Scenario?',
      category: 'Cloud Services',
      image: 'assets/images/blogs/cloud-migrate.png',
      description: 'COVID-19 brought about significant change in a short period. Learn why cloud migration is critical in this scenario.',
      link: 'migrate-cloud',
      type: 'Technology'
    },
    {
      title: 'What is an H1B Visa?',
      category: 'IT Consulting and Staffing',
      image: 'assets/images/blogs/h1bvisa.png',
      description: 'Generally known as a work visa, the H-1B is a non-immigrant employment-based visa provided to eligible temporary workers.',
      link: 'h1b-visa',
      type: 'consulting_staffing'
    },
    {
      title: 'How to Choose Your Digital Partner?',
      category: 'IT Consultancy',
      image: 'assets/images/blogs/digitalpartnerblog.png',
      description: 'In this digital era, having a digital partner is a smart step to take. Learn more in our blog.',
      link: 'digital-partner',
      type: 'consulting_staffing'
    },
    {
      title: 'Importance of Cybersecurity in Business Growth',
      category: 'IT Security',
      image: 'assets/images/blogs/cybersecurityblog.png',
      description: 'While we often think that large businesses are the most affected, cybersecurity is important for businesses of all sizes.',
      link: 'cyber-security',
      type: 'Technology'
    },
    {
      title: 'Hurdles in Embracing Manufacturing IT and Industry 4.0',
      category: 'Cloud Computing',
      image: 'assets/images/blogs/challengesbg.png',
      description: 'The manufacturing sector contributes more than $8 trillion to the US economy. Learn about the challenges of embracing Manufacturing IT and Industry 4.0.',
      link: 'challenges-manufacturing-it-industry-4-0-2',
      type: 'Technology'
    },

  ];
  filteredBlogs: any[] = [];

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
   {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://mitresource.com/blogs/"
        },
        "headline": "Blogs - Technology Consulting and IT services | Maganti IT",
        "description": "Discover how NLP is transforming human-machine communication, paving the way for more intelligent and intuitive technology interactions.",
        "image": "https://mitresource.com/assets/images/blogs/human-machine-img.webp",  
        "author": {
          "@type": "Organization",
          "name": "Maganti IT",
          "url": "https://mitresource.com/"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Maganti IT",
          "logo": {
            "@type": "ImageObject",
            "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
          }
        },
        "datePublished": "2024-10-28"
      }`;

    this._renderer2.appendChild(this._document.head, script);
    this.seoService.createLinkForCanonicalURL();
    this.setTitleAndMetaTags();


    if (this.isBrowser) {
    }
    this.filteredBlogs = this.blogs;
    this.setTitleAndMetaTags();

  }
  filter(value: string) {
    this.selectedFilter = value;
    // console.log(value, "value");
    if (value === 'all') {

      this.filteredBlogs = this.blogs;
    } else {
      this.filteredBlogs = this.blogs.filter(blog => blog.type === value);
    }
  }


  //   selectedFilter: string = 'all';
  //  blogs = [
  //     {
  //         title: 'Unlocking Remote Work\'s Potential',
  //         category: 'HR and Recruiting',
  //         image: 'assets/images/blogs/unlock_remote_work-blog.webp',
  //         description: 'Discover how remote work is reshaping the future of business, enhancing productivity and diversity, and learn practical strategies for organizations to successfully adopt a remote-first approach.',
  //         link: 'unlock_remote_work'
  //     },
  //     {
  //         title: 'What is Smart Manufacturing, and how is it changing the industry?',
  //         category: 'Manufacturing IT',
  //         image: 'assets/images/blogs/smart-manufacturing-blog.webp',
  //         description: 'Discover how smart manufacturing solutions can revolutionize your manufacturing operations, enhancing efficiency, productivity, and market competitiveness.',
  //         link: 'What-is-smart-manufacturing'
  //     },
  //     {
  //         title: 'Power Up your Production: Strategies for OEE Improvement in Your Manufacturing business',
  //         category: 'Manufacturing IT',
  //         image: 'assets/images/blogs/oee-improvement-banner.webp',
  //         description: 'Discover six expert strategies to boost your manufacturing business\'s Overall Equipment Effectiveness (OEE) through custom software solutions.',
  //         link: 'oee-improvement-for-manufacturing'
  //     },
  //     {
  //         title: 'Celebrating Women: Honoring Their Contributions to Society, Family, and Work',
  //         category: 'HR and Recruiting',
  //         image: 'assets/images/banners/celebrating-women-blog.webp',
  //         description: 'Let\'s celebrate and empower women this International Women\'s Day for a more inclusive future. Read the blog.',
  //         link: 'celebrating-women'
  //     },
  //     {
  //         title: 'From Reactive to Proactive: How Predictive Analytics Improves OEE in Manufacturing',
  //         category: 'Manufacturing IT',
  //         image: 'assets/images/blogs/reactive-blog-img.png',
  //         description: 'Learn how predictive analytics can boost equipment utilization by 5% to 15% and enhance OEE metrics, unlocking significant manufacturing benefits.',
  //         link: 'reactivetoproactive-blog'
  //     },
  //     {
  //         title: 'Achieving Harmony: The Importance of Work-Life Balance',
  //         category: 'HR and Recruitment',
  //         image: 'assets/images/blogs/Achievingharmony-blog.png',
  //         description: 'Discover how maintaining a healthy work-life balance, a crucial element for overall well-being, can improve your physical, mental, and emotional health in our latest blog post.',
  //         link: 'Achieving-Harmony-blog'
  //     },
  //     {
  //         title: 'Unlocking the Productivity in the Workplace',
  //         category: 'HR and Recruitment',
  //         image: 'assets/images/blogs/unlocking-img-blog.png',
  //         description: 'In today\'s dynamic professional environment, achieving productivity has become synonymous with achieving success.',
  //         link: 'unlockingtheproductivity-blog'
  //     },
  //     {
  //         title: 'How Technology can Amplify Business Efficiency for Manufacturers in Industry 4.0',
  //         category: 'Infographic',
  //         image: 'assets/images/blogs/blog-img.png',
  //         description: 'Amidst stringent deadlines and personal aspirations, learn how you can tap into your maximum potential and enhance productivity in the workplace. Read the blog.',
  //         link: 'manufacturing_technology_efficiency_industry4_0'
  //     },
  //     {
  //         title: '7 Important Test Cases for Your E-Commerce Website Success',
  //         category: 'Testing Services',
  //         image: 'assets/images/blogs/testcasesimage.png',
  //         description: 'The e-commerce sector has experienced remarkable growth, drawing businesses of all sizes into the digital marketplace.',
  //         link: 'testcasesforecommerce'
  //     },
  //     {
  //         title: 'The Key to Employee Happiness: Achieving Work-Life Balance',
  //         category: 'IT Staffing',
  //         image: 'assets/images/blogs/WorkLifeBalance.png',
  //         description: 'Managing today\'s extensive cloud infrastructure demands modern IT services. Learn more in our blog.',
  //         link: 'it-staffing'
  //     },
  //     {
  //         title: 'AI for E-Commerce: Enhancing Customer Experiences & Business Success',
  //         category: 'Cloud Computing',
  //         image: 'assets/images/blogs/AI-Solutions-bg.png',
  //         description: 'Artificial Intelligence (AI) is proving to be a game-changer in streamlining processes and enhancing customer experiences.',
  //         link: 'ai-solutions'
  //     },
  //     {
  //         title: 'Client Story: Protecting Personal Identifiable Information (PII) using AI/ML',
  //         category: 'Artificial Intelligence',
  //         image: 'assets/images/blogs/pii-banner1.png',
  //         description: 'The financial services industry operates and deals with vast amounts of sensitive data. Learn how AI and ML can protect this information.',
  //         link: 'pii-use-case-ai-ml'
  //     },
  //     {
  //         title: 'Client Story: Cloud Optimization Strategies That Drove 50% Cost Savings',
  //         category: 'Cloud Computing',
  //         image: 'assets/images/blogs/cloud-cost.png',
  //         description: '64% of respondents identified cost management as a key challenge. Learn how cloud optimization strategies can help.',
  //         link: 'cloud-cost-optimization'
  //     },
  //     {
  //         title: 'Planning Cloud Capacity for Unexpected Spikes in Server Workloads',
  //         category: 'Cloud Computing',
  //         image: 'assets/images/blogs/planning-cloud.png',
  //         description: 'Most CIOs and cloud engineers agree on the importance of planning cloud capacity for unexpected spikes in server workloads.',
  //         link: 'planning-cloud-capacity'
  //     },
  //     {
  //         title: 'Personalization and Machine Learning in Marketing',
  //         category: 'Artificial Intelligence',
  //         image: 'assets/images/blogs/blog_mainimage.png',
  //         description: 'Technology is becoming increasingly personalized. Discover how AI and ML are changing the marketing landscape.',
  //         link: 'personalize-and-machine-learning'
  //     },
  //     {
  //         title: 'The New Wave of Digital Marketing in the Post-Pandemic World',
  //         category: 'Digital Marketing',
  //         image: 'assets/images/blogs/digitalmarketingpostpandemic.webp',
  //         description: 'COVID-19 accelerated the pace of digital transformation. Learn about the new wave of digital marketing strategies in our blog.',
  //         link: 'postpandamic'
  //     },
  //     {
  //         title: 'Why is Cloud Migration Critical in the COVID-19 Scenario?',
  //         category: 'Cloud Services',
  //         image: 'assets/images/blogs/cloud-migrate.png',
  //         description: 'COVID-19 brought about significant change in a short period. Learn why cloud migration is critical in this scenario.',
  //         link: 'migrate-cloud'
  //     },
  //     {
  //         title: 'What is an H1B Visa?',
  //         category: 'IT Consulting and Staffing',
  //         image: 'assets/images/blogs/h1bvisa.png',
  //         description: 'Generally known as a work visa, the H-1B is a non-immigrant employment-based visa provided to eligible temporary workers.',
  //         link: 'h1b-visa'
  //     },
  //     {
  //         title: 'How to Choose Your Digital Partner?',
  //         category: 'IT Consultancy',
  //         image: 'assets/images/blogs/digitalpartnerblog.png',
  //         description: 'In this digital era, having a digital partner is a smart step to take. Learn more in our blog.',
  //         link: 'digital-partner'
  //     },
  //     {
  //         title: 'Importance of Cybersecurity in Business Growth',
  //         category: 'IT Security',
  //         image: 'assets/images/blogs/cybersecurityblog.png',
  //         description: 'While we often think that large businesses are the most affected, cybersecurity is important for businesses of all sizes.',
  //         link: 'cyber-security'
  //     },
  //     {
  //         title: 'Hurdles in Embracing Manufacturing IT and Industry 4.0',
  //         category: 'Cloud Computing',
  //         image: 'assets/images/blogs/challengesbg.png',
  //         description: 'The manufacturing sector contributes more than $8 trillion to the US economy. Learn about the challenges of embracing Manufacturing IT and Industry 4.0.',
  //         link: 'challenges-manufacturing-it-industry-4-0'
  //     }
  // ];


  //   filteredBlogs :any= [];



  //   constructor() { }

  //   ngOnInit(): void {
  //     this.filteredBlogs = this.blogs;


  // }
  // ngAfterviewInit(){

  // }
  // filter(value: string) {
  //     this.selectedFilter = value;

  //     if (value === 'all') {
  //         this.filteredBlogs = this.blogs;
  //     } else {
  //         this.filteredBlogs = this.blogs.filter(blog => blog.category === value);
  //     }
  // }
}
